import React from 'react';
import PropTypes from 'prop-types';

import './SectionTitle.css';

function SectionTitle({
    subheading = 'this is subheading',
    heading = 'this is heading',
}) {
    return (
        <div className="section-title">
            <p id="title-p">{subheading}</p>
            <h2 id="title-h2">{heading}</h2>
        </div>
    )
}

SectionTitle.propTypes = {
    subheading: PropTypes.string,
    heading: PropTypes.string
};

export default SectionTitle
